import { Navigate } from 'react-router-dom';

import { adobeDataLayer } from '../lib/adobe-analytics-data-layer/AdobeDataLayer';
import { RouterHelpers } from './router-helpers';

type EntryPointProps = {
  isTransactionCompleted: boolean;
  legalEntity?: string;
};

function EntryPoint({ isTransactionCompleted, legalEntity }: EntryPointProps): JSX.Element {
  const entryPoint = (): string => {
    if ((window as any).du_digitalData) {
      adobeDataLayer.interactionEntryPoint();
    }

    return RouterHelpers.getMatchMakerQuestionPage1Path();
  };

  if (!legalEntity) {
    return <Navigate to={RouterHelpers.get499ErrorPagePath()} />;
  }

  if (isTransactionCompleted) {
    return <Navigate to={RouterHelpers.getConfirmationPagePath()} />;
  }

  return <Navigate to={entryPoint()} />;
}

export default EntryPoint;
